import { IAM_ACCOUNTS_KEY } from '@/constants/QueryKeys';
import useQueryProxy from '@/hooks/useQueryProxy';
import * as iamAccountsUseCase from '@/domains/iamAccounts.usecase';

/**
 * The props for the useIamAccount hook
 * @interface Props
 */
interface Props {
  /**
   * The account ID
   * @type {string | undefined}
   */
  accountId?: string;
  /**
   * Enables re-fetching
   * @type {string | undefined}
   */
  enabled?: boolean;
}

/**
 * Hook to get IAM accounts
 * @param props.accountId The account ID
 * @param props.enabled Enables re-fetching
 */
const useIamAccount = (props: Props) => {
  const { accountId, enabled = true } = props;
  const queryKey = [IAM_ACCOUNTS_KEY, 'account', accountId];

  const { status, data, isFetching, error } = useQueryProxy({
    queryKey,
    queryFn: async (accessToken) => {
      if (accountId == null || accountId === '') {
        return null;
      }
      return await iamAccountsUseCase.getAccount(accountId, accessToken);
    },
    enabled,
  });

  return {
    status,
    data,
    isFetching,
    error,
  };
};

export default useIamAccount;
